<template>  
  <div class="">
    <div class="container clearfix" id=""> 
      <div class="order-list-table tablebox" v-if="count >= 1">
        <table class="downtablelist" style="min-width:1300px;" v-for="(data,index) in goodsList">
          <tr>
            <th :id="data.vbillcode" style="width:33px;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(data,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':data.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i>
            </th>
            <th colspan=8 class="thbox">
              <span class="toptitle fl" style="margin-left: 20px;height: 40px;line-height: 40px;">调拨单号：{{data.vbillcode}}</span>
              <el-form class="fr" style=" display: inline-block;width: 200px !important;height: 34px !important;background: #fff;border-radius: 3px;margin: 3px 20px 0 0">
                <el-input v-model="data.couriernumber" class="tabinp" clearable></el-input>
              </el-form>
              <span  class="fr" style="display: inline-block;height: 40px;line-height: 40px;">* 快递单号：</span>
              <el-form class="fr" style=" display: inline-block;width: 200px !important;height: 34px !important;background: #fff;border-radius: 3px;margin: 3px 20px 0 0">
                <el-input v-model="data.couriername" class="tabinp" clearable></el-input>
              </el-form>
              <span  class="fr" style="display: inline-block;height: 40px;line-height: 40px;">* 快递公司：</span>
              <span class="toptitle fr" style="height: 40px;line-height: 40px;">调入门店：{{data.minstorename}}</span>
             
            </th>
          </tr>
          <tr class="first noimg" v-show="data.listshow =='N'">
            <td style="width:33px;border: 1px solid #eff0f4;" bgcolor="#eff0f4"></td>
            <td style="width:150px;" class="tdtitle">商品编码</td>
            <td style="width:240px;overflow:hidden;text-overflow:ellipsis; white-space:nowrap;" class="tdtitle">商品名称</td>
            <td style="width:70px" class="tdtitle">调拨申请量</td>
            <td style="width:70px" class="tdtitle">历史已发数</td>
            <td style="width:50px" class="tdtitle">单位</td>
         
            <td style="width:110px" class="tdtitle">* 调出货位</td>
            <td style="width:83px" class="tdtitle">* 本次发出数</td>
            <td style="width:70px;text-align: center;padding-right: 20px !important" class="lastbut tdtitle">
              操作
            </td>
          </tr>
          <tr v-for="(item,index2) in data.productList" class="first noimg" v-show="data.listshow =='N'">
            <td style="width:33px;border: 1px solid #eff0f4;" bgcolor="#eff0f4"></td>
            <td style="width:150px">{{ item.productCode }}</td>
            <td style="width:240px;">{{ item.productName }}</td>
            <td style="width:70px">{{ item.nnum }}</td>
            <td style="width:70px">{{ item.outnum==''||item.outnum==null?0:item.outnum }}</td>
            <td style="width:50px">{{ item.cunitname}}</td>
           
            <td style="width:110px;" class="xiugai">
                 <el-input style="width: 110px;border: 1px solid #dcdfe6;border-radius: 4px;padding: 0 15pxbox-sizing: border-box" v-model="item.houtpositionname" placeholder="选择货位" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index,index2)"></el-input>
            </td>
            <td style="width:83px;" class="xiugai">
              <el-input v-model="item.fhnumber" style="border: 1px solid #dcdfe6;border-radius: 4px;padding: 0 15px;box-sizing: border-box"  @blur="numdown(item.nnum,item.outnum,item.fhnumber)" type="number" class="tabinp" clearable></el-input>
            </td>
            <td class="lastbut" style="width:70px;text-align: center;padding-right: 20px !important">
              <el-button type="primary" size="small"class="" @click="handleSubmit(index)" v-if="index2==0">确认发货</el-button>
            </td>
          </tr>
        </table>
      </div>
      <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
        暂无数据
      </div>
      <div class="block" style="text-align: center;margin:20px auto ">
        <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            </span>
      </div>
    </div>
    <div class="model selectmodel" v-show="modelShow">
      <div class="content">
        <div class="title">
          <span class="fl">选择货位</span>
          <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="selectinput">
          <el-form :inline="true" style="padding:10px">
            <el-form-item class="" style="width:100%;margin: 0 !important">
              <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
                <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <div v-show="fullscreenLoading"  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <el-button type="info" v-show="showTop" icon="el-icon-arrow-up" circle id="to-top-btn" style="position:fixed;right:16px;bottom:20px;" @click="toTop"></el-button>
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<style>
</style>
<script>
import { currency } from '../../utils/currency' 
import axios from 'axios'
var self = this;
export default {
  data() {

    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      fullscreenLoading: false,
      modelShow: false,
      tableListindex: 0,
      width: '',
      position: {
        positioncode: '', //货位编码
        positionname: '' //货位名称
      },
      positionList: [],
      user: {},
      mingxiindex: '',
      modelShow: false,
      id: '',
      index1: '',
      goodsindex: '',
      height: 0,
      tuimsgShow: false,
      productName: '',
      OrderType: 4,
      page: 1,
      pagesize: 10,
      count: 0,
      showTop: false, //显示回到顶部按钮
      step: 0, //移动距离
      loading: false,
      vbillcode: '',
      fbillstatus: '',
      faindex: '',
      goodsList: [],
    }
  },
  watch: {

  },
  mounted() {
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.getposition();
    this.init();
  },
  filters: {
    currency: currency
  },
  computed: {},
  destroyed() {
    // sessionStorage.removeItem("productlist");
    sessionStorage.removeItem("positionList");
    sessionStorage.removeItem("buyType");
    sessionStorage.removeItem("vbillcode");
    sessionStorage.removeItem("productName");
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                // console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                        this.modelFlag = true;
                        this.msgShow = true;
                        this.methodName = 'message';
                        this.msg = res.data.message;
                        this.butflag =false;
                        this.butmsg='知道了'; 
                    }
                }, (err) => {
                    this.modelFlag = true;
                    this.methodName = 'message';
                    this.msgShow =false;
                    this.msg = '连接接口失败'+err;
                    this.butflag =false;
                    this.butmsg='知道了'; 
                })
            }else if(this.methodName =='fahuo'){
                  this.fullscreenLoading = true;  
                  var pram = {
                    applybill: JSON.stringify(this.goodsList[this.faindex]),
                    moutstorecode: this.user.storecode,
                    fbillstatus: '4',
                    productName: this.productName, //商品名称
                    pageNum: this.page, //当前页
                    pageSize: this.pagesize //页面数据条数
                  } 
                  // console.log("_+_+_+___+_+_+_+_+__+：" + JSON.stringify(this.goodsList[this.faindex]));
                  //获取数据接口 
                  this.$http.post(this.utilpath + '/SendOutApplybill', pram, { emulateJSON: true,_timeout:600}).then((res) => {
                    // this.$http.post("/ktnapi/SendOutApplybill",pram,{emulateJSON:true}).then((res) => {
                    // this.$http.post(this.InterfacePath+"/SendOutApplybill",pram,{emulateJSON:true}).then((res) => { 
                    if (res.data.status == '0') {
                      this.fullscreenLoading = false;
                      this.$message({
                        showClose: true,
                        message: '发货成功！',
                        type: 'succcess'
                      });
                      this.goodsList = res.data.resultList;
                      this.count = res.data.countNum; 
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                              this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else {
                      this.fullscreenLoading = false; 
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                  }, (err) => {
                    this.fullscreenLoading = false;
                    this.msgShow =false;
                    this.modelFlag = true;
                    this.methodName = 'message';
                    this.msg = '连接获取盘点单接口失败'+err;
                    this.butflag =false;
                    this.butmsg='知道了'; 
                  });
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },  
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1; 
      this.getList();
      //console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val;
      //console.log(this.page);
      this.getList();
    },
    openselectmodel(index,index2) {
      // console.log("model内打印：" + index);
      this.goodsindex = index;
      this.tableListindex = index2;
      this.modelShow = true;

    },
    numdown(num1,num2,num){
      // console.log("进来判断了");
        if(num<0){
            this.$message({
                showClose: true,
                message: '发货数量不能为负数！',
                type: 'error'
           });
        }
        if(num1-num2<num){
            this.$message({
                showClose: true,
                message: '收货数量不能大于发货数量！',
                type: 'error'
           });
        }
    },
    closemodel() {
      this.modelShow = false;
    },
    selectchange(value) {
      // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      this.goodsList[this.goodsindex].productList[this.tableListindex].houtpositioncode = value.positioncode;
      this.goodsList[this.goodsindex].productList[this.tableListindex].houtpositionname = value.positionname; 
      this.modelShow = false;
      this.position = {
        positioncode: '',
        positionname: ''
      };
    },
    getpositions() {
      //获取数据接口
      var reqParam = {
        storecode: this.users.storecode,
        flag: 'Y'
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }      
      }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '连接获取货位接口失败'+err;
          this.butflag =false;
          this.butmsg='知道了'; 
      });
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.user.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
          sessionStorage.setItem("positionList", this.positionList);
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else if (res.data.status == '-1') {
          this.positionList=[]; 
          this.$message({
            showClose:true,
            message:'没有获取到货位信息',
            type:'info'
          }); 
        } else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.messsage;
          this.butflag =false;
          this.butmsg='知道了'; 
          this.positionList = [];
        } 
      }, (err) => {
          this.modelFlag = true;
          this.msgShow = false;
          this.methodName = 'message';
          this.msg = '连接获取货位接口失败';
          this.butflag =false;
          this.butmsg='知道了'; 
 
      });
    },
    //显示隐藏表格
    showlist(item, index) {
      // console.log("展开方法");
      // 取反(true或false)
      this.goodsList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y';  
        this.index1 = index;
        this.id = item.vbillcode;
        this.toTop(); 
    },
    scrollEvent(e) { 
      this.showTop = e.srcElement.scrollTop > 800 ? true : false;
      //滚动的像素+容器的高度>可滚动的总高度-20像素
      // console.log("触发滚动事件");
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 20 && this.loading) {
        this.getList(true); //加载更多
      }
    },
    toTop() {
      var idmsg = ''
      if (this.id != '') {
        idmsg = this.id;
        // console.log("-=-=-=-=-=-=--=-:" + idmsg);
      } else {
        idmsg = 'contain';
        // console.log("-=-=-=-=-=-=--=-:" + idmsg);
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step += dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        // this.step+=dis
        var c = setTimeout(() => this.toTop(), 16);
      } else {
        clearTimeout(c);
      }
    },
    col(msg) { //实时计算列合并数
      if (msg.fbillstatus == '5') {
        return 8;
      } else { return 7; }
    },
    //获取数据
    getList() {
      this.fullscreenLoading = true;
      var reqParams = {
        moutstorecode: this.user.storecode, //门店编码  
        forderstatus: '4', //单据状态 
        pageNum: this.page, //当前页
        pageSize: this.pagesize //页面数据条数
      }
      // console.log("----------------------------传递参数：" + JSON.stringify(reqParams))
      // console.log("----------------------------打印地址：" + this.utilpath + '/selectReceived')
      var methodname = '';
      //获取数据接口 
      this.$http.post(this.utilpath + '/selectReceived', reqParams, { emulateJSON: true,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectReceived',reqParams,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectReceived',reqParams,{emulateJSON:true}).then((res) => { 
        //console.log("_+_+_调用方法+_+_")
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          this.goodsList = res.data.resultList;
          this.count = res.data.countNum;
          //console.log("----------------------------打印数据：" + JSON.stringify(this.goodsList))
          // sessionStorage.setItem("productlist",JSON.stringify(this.goodsList));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false
          this.goodsList = [];
          this.count = res.data.countNum;
          //console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false
          this.modelFlag= true;
          this.msgShow= true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag=false;
          this.butmsg='知道了'; 
        }
        // console.log("获取的JSON数据"+JSON.stringify(res.result));       
      }, (err) => {
        this.fullscreenLoading = false; 
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '连接查询盘点信息接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
        //console.log(err);
      });
    },
    init() {
      this.widthdata = document.documentElement.clientWidth - 254;
      this.width = document.documentElement.clientWidth - 220; 
      //console.log("-=-=-1111打印用户=--=-" + JSON.stringify(window.localStorage.getItem("userInfo")));
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      // if(goods == null){
      //console.log("空");
      this.getList();
      this.getposition(); 
    },
    handleSubmit(index) { //发货
      var flag = true;
      var flag2 = false;
      var flag3 = false;
      // console.log("11111111最外层打印" + this.goodsList[index].couriernumber);
      if (this.goodsList[index].couriernumber === null || this.goodsList[index].couriernumber === '' || this.goodsList[index].couriernumber === undefined||this.goodsList[index].couriername === null || this.goodsList[index].couriername === '' || this.goodsList[index].couriername === undefined) {
        this.$message({
          showClose: true,
          message: '快递单号或快递公司不能为空！',
          type: 'error'
        });
      } else {
        // console.log("2222222222222222非空打印");
        // this.goodsList[this.index].productList.forEach((item) => {
        this.goodsList[index].productList.forEach((item) => {
          // console.log("========================"+item.positionname);
          if (item.fhnumber == '' || item.fhnumber == null || item.fhnumber === undefined) {
            //console.log("-=-=-=-=-=-=-=-" + item.fhnumber + "-=-=-=-=-=-=-=-" + item.houtpositioncode);
            flag = false;
            return;
          }
          if(item.fhnumber<0){
            flag2 = true
          }
          if(item.nnum-item.outnum<item.fhnumber){
            flag3 = true
          }
        });
        if (!flag) {
          //console.log("3333333333333333发货数量为空打印");
          this.$message({
            showClose: true,
            message: '发货数量不能为空！',
            type: 'error'
          });
        }else if(flag2){ 
            this.$message({
                showClose: true,
                message: '收货数量不能为负数！',
                type: 'error'
           });
        }else if(flag3){
            this.$message({
                showClose: true,
                message: '收货数量不能大于发货数量！',
                type: 'error'
           });
        }else {
          this.faindex = index;
          this.methodName = 'fahuo';
          this.modelFlag = true;
          this.msgShow = false;
          this.butflag = true;
          this.butmsg='确认';
          this.msg = '确认发货？'
          
        }

      }
    }

  }
}

</script>



// WEBPACK FOOTER //
// src/views/stock/diaobofahuo.vue